module.exports = __webpack_public_path__ + "static/media/check1st.d7e6b151.svg";